<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/71dqMI/media/cover_9781800321007.jpg?1695331341345" alt="This image is the cover for the book Granville Affair, The Granville Sisters Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Granville Affair, The Granville Sisters Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>The women of the Granville family find their lives changed—and endangered—as World War II rages in this novel in the “sweeping and poignant series” (<i>Booklist</i>).</b><br/>  <br/> The Granville family has fled bomb-torn London for Hartley Hall in Surrey, but even away from the city, life remains turbulent. Rosie is trapped in a loveless marriage to a penniless peer. With her husband away fighting, she finds the temptations that come with his absence too much to avoid.<br/> Meanwhile, her younger sister Juliet’s world comes crashing down when she must face a tragedy without the support of the only man she has ever loved. Desperate to forget her past, she puts herself in the line of danger as a Red Cross nurse, braving the carnage of the Blitz.<br/><br/> And the fragile peace at Hartley Hall is disrupted further when fifteen-year-old Louise becomes involved with an East End evacuee—and threatens the family with yet another scandal . . .<br/><br/><b>Praise for the Granville novels</b><br/><br/> “A gripping and enjoyable historical saga filled with one family's triumphs and tragedies set against a broad canvas.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Una-Mary Parker
      </h2>
      
      <p class="authorDescription body article"><P>Una-Mary Parker always had a passion for writing, working on several newspapers and later for British <I>Tatler</I>, she was also a prolific broadcaster. A celebrated beauty, born to the life she writes about, her sensational debut novel, <I>Riches</I>,<I></I>was published to outstanding international critical acclaim. A glamorous and well known society figure, she leaves a huge legacy of books for women who relish romance, intrigue, passion and inspiration.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Digital Publishing Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?014678ee